import { FileText, Download, Trash2 } from "lucide-react";
import { Button } from "@/shared/ui/button";
import { Badge } from "@/shared/ui/badge";
import {
  DocumentListItem as DocumentListItemType,
  formatDocumentDate,
  getDocumentTypeLabel,
} from "./utils";

interface DocumentListItemProps {
  item: DocumentListItemType;
  onDelete: (item: DocumentListItemType) => void;
  disabled?: boolean;
}

export function DocumentListItem({ item, onDelete, disabled }: DocumentListItemProps) {
  const document = item.document;
  const createdLabel =
    item.kind === "existing"
      ? `Enviado em ${formatDocumentDate(document.createdAt)}`
      : `Criado em ${formatDocumentDate(document.createdAt)} • Aguarda envio`;
  const canOpenLink = Boolean(document.documentUrl);

  return (
    <li key={`${item.kind}-${document.id}`} className="rounded-md border bg-muted/30 p-4">
      <div className="flex flex-col gap-3 md:flex-row md:items-start md:justify-between">
        <div className="flex flex-1 gap-3">
          <div className="mt-1 text-muted-foreground">
            <FileText className="h-5 w-5" />
          </div>
          <div className="min-w-0 space-y-2">
            <div className="flex flex-wrap items-center gap-2">
              <Badge variant="secondary">
                {getDocumentTypeLabel(document.documentType)}
              </Badge>
              {item.kind === "pending" && (
                <Badge variant="outline" className="border-amber-200 bg-amber-50 text-amber-700">
                  Pendente
                </Badge>
              )}
              <span className="text-xs text-muted-foreground">{createdLabel}</span>
            </div>
            {document.description ? (
              <p className="break-words text-sm text-muted-foreground">{document.description}</p>
            ) : (
              <p className="text-sm italic text-muted-foreground">Sem descrição</p>
            )}
            {item.kind === "pending" && document.file && (
              <p className="text-xs text-muted-foreground">
                Arquivo selecionado: {document.file.name}
              </p>
            )}
          </div>
        </div>
        <div className="flex items-center gap-1 self-start md:self-center">
          {canOpenLink && (
            <Button asChild variant="ghost" size="icon" title="Abrir documento">
              <a href={document.documentUrl} target="_blank" rel="noopener noreferrer">
                <Download className="h-4 w-4" />
              </a>
            </Button>
          )}
          <Button
            type="button"
            variant="ghost"
            size="icon"
            className="text-destructive hover:text-destructive"
            onClick={() => onDelete(item)}
            disabled={disabled}
            title="Remover documento"
          >
            <Trash2 className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </li>
  );
}

